import { Blue80, Button } from '@traceair/tds';
import React from 'react';
import { stylesheet } from 'typestyle';
import { Customer, Site } from '../../../../../../types';
import { trackAction } from '../../../../../../libs/analytics/ActionTracking';
import { DownloadIcon } from '@traceair/webapp-icons';

const css = stylesheet({
  button: {
    marginTop: 8,
  },
});

interface Props {
  customer: Customer;
  site: Site;
}

export const DownloadGcpRequestButton = ({ customer, site }: Props) => {
  const handleClick = () => {
    trackAction('Click to "Download CSV" button', { customer, site });
    window.open(GcpAppUrl + `?downloadCsv=true#/customers/${customer.id}/sites/${site.id}/current-gcp-request`);
  };

  return (
    <Button
      className={css.button}
      style="secondary"
      text="Download CSV"
      icon={<DownloadIcon color={Blue80} />}
      fullWidth
      size="xs"
      onClick={handleClick}
    />
  );
};
